import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import { Permission } from '../utils/permissions';
import { UserRole } from '../types';

interface PermissionRouteProps {
  children: React.ReactNode;
  permission: Permission;
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({ children, permission }) => {
  const { can, role } = usePermissions();

  if (!can(permission)) {
    const fallback = role === UserRole.END_USER ? '/tickets' : '/dashboard';
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
};

export default PermissionRoute;
